export class ReferenceDataContextualHelps {
  public static readonly KfiAboutTheMortgage = 'KfiAboutTheMortgage';
  public static readonly KfiAboutTheFees = 'KfiAboutTheFees';
  public static readonly KfiAboutApplicants = 'KfiAboutApplicants';
  public static readonly KfiPurchaseConcessionary = 'KfiPurchaseConcessionary';
  public static readonly ProductSelection = 'ProductSelection';
  public static readonly KfiLoanAmmountBtl = 'KfiLoanAmmountBtl';
  public static readonly KfiLoanAmmountResidential = 'KfiLoanAmmountResidential';
  public static readonly KfiBorrowingTermResidential = 'KfiBorrowingTermResidential';
  public static readonly KfiBorrowingTermBtl = 'KfiBorrowingTermBtl';
  public static readonly KfiRepaymentType = 'KfiRepaymentType';
  public static readonly IsRecommendedCode = 'FeesIsRecommendedCode';
  public static readonly FeesValuationReportType = 'FeesValuationReportType';
  public static readonly FeeArrangementIncluded = 'FeeArrangementIncluded';
  public static readonly FeeHigherLendingIncluded = 'FeeHigherLendingIncluded';
  public static readonly AppAboutTheMortgage = 'AppAboutTheMortgage';
  public static readonly AppPurchaseConcessionary = 'AppPurchaseConcessionary';
  public static readonly AppPropertyEstimatedValueResidential = 'AppPropertyEstimatedValueResidential';
  public static readonly AppPropertyEstimatedValueBtl = 'AppPropertyEstimatedValueBtl';
  public static readonly AppLoanAmmountBtl = 'AppLoanAmmountBtl';
  public static readonly AppLoanAmmountResidential = 'AppLoanAmmountResidential';
  public static readonly AppBorrowingTermBtl = 'AppBorrowingTermBtl';
  public static readonly AppBorrowingTermResidential = 'AppBorrowingTermResidential';
  public static readonly AppDepositSources = 'AppDepositSources';
  public static readonly AppNoOfDependants = 'AppNoOfDependants';
  public static readonly AppAboutApplicant = 'AppAboutApplicant';
  public static readonly AppAnnualBasicSalary = 'AppAnnualBasicSalary';
  public static readonly AppFutureEvents = 'AppFutureEvents';
  public static readonly AppEarnedGrossIncomeBtl = 'AppEarnedGrossIncomeBtl';
  public static readonly AppEarnedGrossIncomeResidential = 'AppEarnedGrossIncomeResidential';
  public static readonly AppOtherBtlWithUsDetails = 'AppOtherBtlWithUsDetails';
  public static readonly AppHowManyBtlInTotal = 'AppHowManyBtlInTotal';
  public static readonly AppHoldAnyOtherNonBtl = 'AppHoldAnyOtherNonBtl';
  public static readonly AppHowManyBtl = 'AppHowManyBtl';
  public static readonly AppAboutOutgoings = 'AppAboutOutgoings';
  public static readonly AppOutgoingDetails = 'AppOutgoingDetails';
  public static readonly AppOutgoingType = 'AppOutgoingType';
  public static readonly AppAboutProperty = 'AppAboutProperty';
  public static readonly AppTenureType = 'AppTenureType';
  public static readonly AppPropertyExPublicSector = 'AppPropertyExPublicSector';
  public static readonly AppQuoteFromOurLegal = 'AppQuoteFromOurLegal';
  public static readonly AppSolicitorAddress = 'AppSolicitorAddress';
  public static readonly AppSolicitorFirmWarning = 'AppSolicitorFirmWarning';
  public static readonly AppFirmNameNonLmsReferral = 'AppFirmNameNonLmsReferral';
  public static readonly AppFirmNameLmsReferral = 'AppFirmNameLmsReferral';
  public static readonly AppRemortgageLoanRepayment = 'AppRemortgageLoanRepayment';
  public static readonly WhatIsTheorPriceOfTheProId = 'PropertyPurchasePrice';
  public static readonly WhatIsTheTrueMarketValueOfThePId = 'PropertyMarketValue';
  public static readonly ConcessionNature = 'ConcessionNature';
  public static readonly MortgagePayOffAmountResidential = 'MortgagePayOffAmountResidential';
  public static readonly MortgageRemainderFundingDetails = 'MortgageRemainderFundingDetails';
  public static readonly ReMortgageHomeImprovementBTL = 'ReMortgageHomeImprovementBTL';
  public static readonly ReMortgageOtherPropertyImprovement = 'ReMortgageOtherPropertyImprovement';
  public static readonly PleaseProvideDetails = 'PleaseProvideDetails';
  public static readonly ReMortgageSchoolFeesOrPension = 'ReMortgageSchoolFeesOrPension';
  public static readonly ReMortgageBusinessInvestment = 'ReMortgageBusinessInvestment';
  public static readonly ReMortgageAdditionalPropertyBTL = 'ReMortgageAdditionalPropertyBTL';
  public static readonly ReMortgageOutrightPropertyPurchaseBTL = 'ReMortgageOutrightPropertyPurchaseBTL';
  public static readonly ReMortgageCostsAndFees = 'ReMortgageCostsAndFees';
  public static readonly RedemptionMortgageOnOtherProperty = 'RedemptionMortgageOnOtherProperty';
  public static readonly OtherAdditionalRemortgage = 'OtherAdditionalRemortgage';
  public static readonly ReMortgageHomeImprovement = 'ReMortgageHomeImprovement';
  public static readonly ReMortgageAdditionalProperty = 'ReMortgageAdditionalProperty';
  public static readonly ReMortgageOutrightPropertyPurchase = 'ReMortgageOutrightPropertyPurchase';
  public static readonly ProductCodeRequired = 'ProductCodeRequired';
  public static readonly ProductType = 'ProductType';
  public static readonly ProductName = 'ProductName';
  public static readonly PropertySharePercentage = 'PropertySharePercentage';
  public static readonly MonthlyRentalForNotPurchasedProperty = 'MonthlyRentalForNotPurchasedProperty';
  public static readonly InterestAnyOtherProperty = 'InterestAnyOtherProperty';
  public static readonly InterestOnlyPartId = 'InterestOnlyPart';
  public static readonly RepaymentPartId = 'RepaymentPartId';
  public static readonly TotalLoan = 'TotalLoan';
  public static readonly RepaymentMethodInterestOnly = 'RepaymentMethodInterestOnly';
  public static readonly RepaymentMethodLoan = 'RepaymentMethodLoan';
  public static readonly AreRepaymentAssetsInSterlingCode = 'AreRepaymentAssetsInSterlingCode';
  public static readonly ContinuingMonthlyPaymentsOnOutgoings = 'ContinuingMonthlyPaymentsOnOutgoings';
  public static readonly MonthlySponsorOutgoings = 'MonthlySponsorOutgoings';
  public static readonly AgeOfFinancialDependant = 'AgeOfFinancialDependant';
  public static readonly TotalLoanAmounts = 'TotalLoanAmounts';
  public static readonly OtherBtlWithUsDetails = 'OtherBtlWithUsDetails';
  public static readonly BankBuildingSocietyName = 'BankBuildingSocietyName';
  public static readonly AccountHolderName = 'AccountHolderName';
  public static readonly SortCode = 'SortCode';
  public static readonly AccountNumber = 'AccountNumber';
  public static readonly IsValuationCompletedBeforeId = 'IsValuationCompletedBefore';
  public static readonly ValuationReportPayerTypeId = 'ValuationReportPayerType';
  public static readonly ValuationCompanyNameId = 'ValuationCompanyName';
  public static readonly ValuationCompletedValueId = 'ValuationCompletedValue';
  public static readonly SurveyCompletedById = 'SurveyCompletedBy';
  public static readonly IsValuationReportWithin12Weeks = 'IsValuationReportWithin12Weeks';
  public static readonly ValuationFeeAmountId = 'ValuationFeeAmount';
  public static readonly IsMortgageClubSubmissionId = 'IsMortgageClubSubmission';
  public static readonly MembershipNumber = 'MembershipNumber';
  public static readonly FeePayableAtApplicationId = 'FeePayableAtApplication';
  public static readonly FeePayableAtOfferId = 'FeePayableAtOffer';
  public static readonly FeePayableAtCompletionId = 'FeePayableAtCompletion';
  public static readonly BookingFeeId = 'BookingFee';
  public static readonly TotalProcurationFeePayable = 'TotalProcurationFeePayable';
  public static readonly ProcurationFeePayableTo = 'ProcurationFeePayableTo';
  public static readonly AdvisedAppAnnualBasicSalary = 'AdvisedAppAnnualBasicSalary';
  public static readonly AdvisedAppLoanAmmountResidential = 'AdvisedAppLoanAmmountResidential';
  public static readonly AdvisedAppHowManyBtl = 'AdvisedAppHowManyBtl';
  public static readonly AdvisedKfiLoanAmmountResidential = 'AdvisedKfiLoanAmmountResidential';
  public static readonly AdvisedKfiBorrowingTermResidential = 'AdvisedKfiBorrowingTermResidential';
  public static readonly AdvisedAppBorrowingTermResidential = 'AdvisedAppBorrowingTermResidential';
  public static readonly GrossAnnualContractIncome = 'GrossAnnualContractIncome';
  public static readonly EmploymentStatusCode = 'EmploymentStatusCode';
  public static readonly EmploymentTypeCode = 'EmploymentTypeCode';
  public static readonly IsLoanSponsorCode = 'IsLoanSponsorCode';
  public static readonly NumberOfSponsorDependents = 'NumberOfSponsorDependents';
  public static readonly DateCIDDIssued = 'DateCIDDIssued';
  public static readonly IsNICHAApplication = 'IsNICHAApplication';
  public static readonly DateNICHALetterReceivedL = 'DateNICHALetterReceived';
  public static readonly RepaymentMonthlyCost = 'RepaymentMonthlyCost';
  public static readonly RepaymentMaturityDate = 'RepaymentMaturityDate';
  public static readonly RepaymentProjectedValue = 'RepaymentProjectedValue';
  public static readonly AgeAtMortgageTerm = 'AgeAtMortgageTerm';
  public static readonly YearEnding1 = 'YearEnding1';
  public static readonly NetProfit1 = 'NetProfit1';
  public static readonly YearEnding2 = 'YearEnding2';
  public static readonly NetProfit2 = 'NetProfit2';
  public static readonly TotalIncome = 'TotalIncome';
  public static readonly HasMortgageAnERC = 'HasMortgageAnERC';
  public static readonly ERCAmount = 'ERCAmount';
  public static readonly ERCEndDate = 'ERCEndDate';
  public static readonly IsPortableMortgage = 'IsPortableMortgage';
  public static readonly OutstandingBalanceAmount = 'OutstandingBalanceAmount';
  public static readonly TotalMonthlyPayment = 'TotalMonthlyPayment';
  public static readonly IsPayedOffWithMortgage = 'IsPayedOffWithMortgage';
  public static readonly IsSecuredAgainstProperty = 'IsSecuredAgainstProperty';
  public static readonly ApplicantPriority1 = 'ApplicantPriority1';
  public static readonly ApplicantPriority2 = 'ApplicantPriority2';
  public static readonly ApplicantPriority3 = 'ApplicantPriority3';
  public static readonly RepaymentTypeCode = 'RepaymentTypeCode';
  public static readonly ReasonForRepaymentType = 'ReasonForRepaymentType';
  public static readonly ValuationReportTypeCode = 'ValuationReportTypeCode';
  public static readonly ApplicationDepositSourceTypes = 'ApplicationDepositSourceTypes';
  public static readonly ApplicationDepositSourceTypesForRemortgage = 'ApplicationDepositSourceTypesForRemortgage';
}
